import {createSlice, PayloadAction} from '@reduxjs/toolkit'

import {BookingManagementStage} from './bookingManagementStage'

interface BookingManagementState {
  // which screen the BMP gate currently renders
  stage: BookingManagementStage
}

export const initialState: BookingManagementState = {
  stage: BookingManagementStage.Loading
}

const {reducer, actions} = createSlice({
  name: 'bookingManagement',
  initialState,
  reducers: {
    setBookingManagementStage: (
      state,
      {payload}: PayloadAction<BookingManagementStage>
    ) => {
      state.stage = payload
    }
  }
})

export const {setBookingManagementStage} = actions

export default reducer
